export default "__VITE_ASSET__fb74e7e5__"